import CardWrapper from "../../HOC/card/card";
import SectionTitle from "../../components/section-title";
import StatisticsChart from "../../components/statistics-chart";
import { EyeOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Col, Row, Table } from "antd";
import { Link } from "react-router-dom";
import CustomTable from "../custom-table";

const gainerTypes2 = [
  {
    label: "تعليمي",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#5b3f61", stroke: "#5b3f61" },
  },
  {
    label: "دعوي",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#a562c0", stroke: "#a562c0" },
  },
  {
    label: "تربوي",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#5abf61", stroke: "#5abf61" },
  },
  {
    label: "صحي",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#ca60c0", stroke: "#ca60c0" },
  },
  {
    label: "اغاثي",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#db4f61", stroke: "#db4f61" },
  },
  {
    label: "اجتماعي",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#7450c0", stroke: "#7450c0" },
  },
  {
    label: "عام",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#74b0c0", stroke: "#74b0c0" },
  },
  {
    label: "غير ذلك",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#cff0c0", stroke: "#cff0c0" },
  },
];

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    align: "center",
    render: (text, record) => <b>{text}</b>,
  },
  {
    title: "اسم الجهة",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "المدينة",
    dataIndex: "city",
    key: "city",
    align: "center",
  },
  {
    title: "المنطقة",
    dataIndex: "region",
    key: "region",
    align: "center",
  },
  {
    title: "تقييم الجهة",
    dataIndex: "eval",
    key: "eval",
    align: "center",
  },
  {
    title: "الدعم",
    dataIndex: "fund",
    key: "fund",
    align: "center",
  },
  {
    title: "المهام",
    key: "action",
    render: (text, record) => (
      <Link to="/" style={{ color: " #0B632D" }}>
        <EyeOutlined />
      </Link>
    ),
    align: "center",
  },
];

const data = [
  {
    key: "1",
    name: "جمعية الصفا",
    city: "صفوي",
    region: "صفوي",
    eval: 3.5,
    fund: "مدعوم",
  },
  {
    key: "2",
    name: "جمعية الصفا",
    city: "صفوي",
    region: "صفوي",
    eval: 4.4,
    fund: "مدعوم",
  },
  {
    key: "3",
    name: "جمعية الصفا",
    city: "صفوي",
    region: "صفوي",
    eval: 2.4,
    fund: "غير مدعوم",
  },
  {
    key: "4",
    name: "جمعية الصفا",
    city: "صفوي",
    region: "صفوي",
    eval: 2.4,
    fund: "غير مدعوم",
  },
];

const StatisticsPage2 = ({ handleChangePage }) => {
  return (
    <Row className="statistics-row-container" gutter={16}>
      <Col
        className="gutter-row arrows-container"
        xxl={14}
        xl={14}
        lg={14}
        md={24}
        sm={24}
        xs={24}
      >
        <CardWrapper classes="gainer-types mt-0">
          <SectionTitle title="المدن والمناطق" />
          <CustomTable
            scroll={{ x: "100%" }}
            pagination={false}
            columns={columns}
            dataSource={data}
          />
        </CardWrapper>
        <div className="stat-arrows-container">
          <RightOutlined
            onClick={() => handleChangePage(0)}
            className="stat-arrows stat-right-arrow"
          />
          <LeftOutlined
            className="stat-arrows stat-left-arrow"
            style={{ color: "gray" }}
          />
        </div>
      </Col>
      <Col
        className="gutter-row"
        xxl={10}
        xl={10}
        lg={10}
        md={24}
        sm={24}
        xs={24}
      >
        <CardWrapper classes="gainer-types mt-0">
          <SectionTitle title="مجالات المشروعات" />
          <StatisticsChart data={gainerTypes2} />
        </CardWrapper>
      </Col>
    </Row>
  );
};
export default StatisticsPage2;
